/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ModalConfirm } from "@nordcloud/gnui";
import { CloudResourceReportStatus } from "~/generated/graphql";
import { useDeleteCloudResourceReport } from "~/views/resources_v2/ResourceReports/hooks";

type Props = {
  reportId: string;
  reportName: string;
  reportStatus: CloudResourceReportStatus;
  isDeleteModalOpen: boolean;
  close: () => void;
};

export function DeleteModal({
  reportId,
  reportName,
  reportStatus,
  isDeleteModalOpen,
  close,
}: Props) {
  const [deleteCloudResourceReport] = useDeleteCloudResourceReport({
    reportName: reportName,
    reportStatus: reportStatus,
  });

  const onDelete = () => {
    deleteCloudResourceReport({
      id: reportId,
    });
    close();
  };

  return (
    <ModalConfirm
      onClose={close}
      isOpen={isDeleteModalOpen}
      confirm={onDelete}
      actionLabel="Delete"
      data-testid="modal-delete-report-generation"
      contentLabel={`Delete Report`}
    >
      {`Are you sure you want to delete ${reportName}?`}
    </ModalConfirm>
  );
}
